import type { TripAdjustmentQuote } from "./bookings-api";

/** Missing is not zero: never invent an earnings increase from absent evidence. */
export function knownMoney(value: unknown): number | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

export type RequestFinancialSnapshot = Pick<TripAdjustmentQuote,
  "rentalFee" | "deliveryFee" | "serviceFee" | "insuranceFee" | "paymentDue"
> & Omit<Partial<TripAdjustmentQuote>, "ownerEarn"> & { ownerEarn?: number | null };

export function hasRequestFinancialSnapshot(value: RequestFinancialSnapshot | null): boolean {
  return value != null && ["rentalFee", "deliveryFee", "serviceFee", "insuranceFee", ...(value.financialAudience === "host" ? [] : ["paymentDue"])]
    .every(key => knownMoney(value[key as keyof RequestFinancialSnapshot]) != null);
}